<script setup>
import {computed, ref} from "vue"
import {router, usePage} from "@inertiajs/vue3"
import CLink from "@/Components/CLink.vue"
import {VNumberInput} from 'vuetify/labs/VNumberInput'


const page = usePage()

const stockRange = ref(page.props.stockFilter)
const maxLocalStock = Number(stockRange.value.local_max)
const maxSupplierStock = Number(stockRange.value.fornecedor_max)
const minStockRange = Number(stockRange.value.min_stock)

const supplierStock = ref(stockRange.value.supplier_stock)
const localStock = ref(stockRange.value.local_stock)

const calcMaxStock = computed(() => {
    return supplierStock
        ? (maxLocalStock + maxSupplierStock)
        : maxLocalStock
})

const stockSlider = ref(minStockRange)

const updateValue = () => {
    if (!localStock.value && !supplierStock.value) {
        if (localStock.value === false) {
            localStock.value = true
        } else {
            supplierStock.value = true
        }
        return
    }

    const params = route().params
    delete params.page

    router.get(route(route().current(), {
        ...params,
        'min_stock': stockSlider.value,
        'supplier_stock': supplierStock.value,
        'local_stock': localStock.value
    }), {}, {preserveState: false})
}

const hasFilterParams = computed(() => {
    const params = route().params
    return !!(params.min_stock || params.supplier_stock || params.local_stock)
})

const hasSliderChanged = computed(() => {
    return stockSlider.value !== minStockRange
})

const showFilterButton = computed(() => {
    return !hasFilterParams.value || hasSliderChanged.value
})


const routeParamsClean = route().params
delete routeParamsClean.min_stock
delete routeParamsClean.supplier_stock
delete routeParamsClean.local_stock
</script>

<template>
    <v-sheet class="pa-2">
        <v-row>
            <v-col cols="12">
                <p class="pb-2">Minimo em estoque</p>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6">
                <v-checkbox label="Estoque Creative" @change="updateValue" v-model="localStock" ></v-checkbox>
                <v-checkbox label="Estoque Fornecedor" @change="updateValue" v-model="supplierStock"></v-checkbox>
            </v-col>
            <v-col cols="6" class="">
                <v-number-input
                    controlVariant="hidden"
                    v-model="stockSlider"
                    :model-value="stockSlider === 0 ? null : stockSlider"
                    label="Quantidade"
                    @keyup.enter="updateValue"
                ></v-number-input>

                <v-btn v-if="showFilterButton" width="130px" @click="updateValue()" variant="flat" color="primary">Filtrar</v-btn>

                <c-link v-else variant="flat" class="float-end" :href="route(route().current(), routeParamsClean)">
                    <v-btn width="130px" variant="flat" color="grey">Limpar</v-btn>
                </c-link>
            </v-col>
        </v-row>
    </v-sheet>
</template>
